import { render, staticRenderFns } from "./ActionTr.vue?vue&type=template&id=d36d5c2c&scoped=true"
import script from "./ActionTr.vue?vue&type=script&lang=js"
export * from "./ActionTr.vue?vue&type=script&lang=js"
import style0 from "./ActionTr.vue?vue&type=style&index=0&id=d36d5c2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36d5c2c",
  null
  
)

export default component.exports